// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__2pR3O","label":"Checkbox_label__sOdDM"};